var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { BreadCrumb, BreadCrumbsWrapper, BreadCrumbWrapper, CaretIcon, } from './styles';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../../components/UI-helpers/colors';
var BreadcrumbsAppBuilder = function (_a) {
    var crumbs = _a.crumbs, onCrumbClick = _a.onCrumbClick;
    var navigate = useNavigate();
    var onCrumbClickAction = function (path) {
        navigate(path);
    };
    var onCrumbClickToUse = onCrumbClick || onCrumbClickAction;
    return (_jsx(BreadCrumbsWrapper, { children: crumbs.map(function (item, index) { return (_jsxs(BreadCrumbWrapper, __assign({ onClick: function () {
                onCrumbClickToUse && item.to && onCrumbClickToUse(item.to);
            } }, { children: [_jsx(BreadCrumb, { children: item.text }), crumbs.length !== index + 1 && (_jsx(CaretIcon, { children: _jsx(FontAwesomeIcon, { color: colors.muted, style: { fontSize: 12 }, icon: faChevronRight }) }))] }), item.text)); }) }));
};
var mapDispatchToProps = function () { return ({}); };
export default connect(null, mapDispatchToProps)(BreadcrumbsAppBuilder);
